import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getBonusTasks, submitBonusTask} from 'game/app/actions/bonus-tasks-actions';
import BonusTaskForm from "../../common/bonus-task-form";
import {Link, Route, Switch} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import Oblast1 from "./oblast_1";
import Oblast2 from "./oblast_2";
import Oblast3 from "./oblast_3";
import Oblast4 from "./oblast_4";
import Oblast5 from "./oblast_5";
import Oblast6 from "./oblast_6";
import Oblast7 from "./oblast_7";
import assets from "game/app/assets";
import {setTheme} from "game/app/actions/theme-actions";


class BonusTasksIndex extends GameComponent {

    componentWillMount() {
        this.props.getBonusTasks(this.props.match.params.instance_id);
    }

    componentDidMount() {
        this.props.setTheme('bonuses');
    }

    componentWillUnmount() {
        this.props.setTheme('ingame');
    }

    submitBonusTask(task) {
        return (values, form) => {
            this.props.submitBonusTask(this.getInstanceId(), task.id, values).then(() => {
                form.resetForm();
                form.setSubmitting(false);
            });
        }
    }

    showTask(id) {
        return this.props.bonusTasks.list.filter((task) => task.id === id ).map((task) => <BonusTaskForm key={task.id} resource={task} handleSubmit={this.submitBonusTask(task)}/>)
    }

    render() {
        let instanceId = this.props.match.params.instance_id;

        return (
            <div className='container'>
                <h1 className='page-title-minor separate-bottom'>Bonusové úkoly</h1>
                <Switch>
                    <Route path='/game/:instance_id/bonus-tasks/1' component={Oblast1}/>
                    <Route path='/game/:instance_id/bonus-tasks/2' component={Oblast2}/>
                    <Route path='/game/:instance_id/bonus-tasks/3' component={Oblast3}/>
                    <Route path='/game/:instance_id/bonus-tasks/4' component={Oblast4}/>
                    <Route path='/game/:instance_id/bonus-tasks/5' component={Oblast5}/>
                    <Route path='/game/:instance_id/bonus-tasks/6' component={Oblast6}/>
                    <Route path='/game/:instance_id/bonus-tasks/7' component={Oblast7}/>
                    <Route render={() => {
                        return (
                            <div className={this.mainContainerClass}>
                                <p>Oblasti bonusových úkolů jsou zaměřeny na různé nástroje, pomocí nichž se můžete finančně vzdělávat. Obsahují různé formy získávání informací a rozvíjení schopností a celkově kompetencí.</p>
                                <p>Oblastí je připraveno celkem 7. Můžete si vybrat jenom některé kategorie nebo udělat od každé kousek. Chechtáky bude oceněna vaše AKTIVITA – čím více úkolů splníte, tím více chechtáčků se přikutálí.</p>
                                <p><b>Zpracované úkoly nahrávejte přímo do aplikace přes formuláře v dané kategorii. Je možné nahrát různé formáty (.doc, .pdf, obrázek …). VIDEA nahrávejte nejdříve na YouTube nebo na cloudové úložiště a do aplikace vložte odkaz.</b></p>
                                <p>V jednotlivých oblastech najdete 3 typy úkolů:</p>
                                <ol type='a' className='separate-bottom'>
                                    <li>
                                        <div><b>ZNALOSTNÍ</b></div>
                                        <p>Tyto úkoly budou rozvíjet zejména vaše znalosti v oblasti domácího hospodaření a dalších témat finančního vzdělávání. Jejich zpracování je méně náročné a zvládne je opravdu každý.</p>
                                    </li>
                                    <li>
                                        <div><b>TVOŘIVÉ</b></div>
                                        <p>Tento typ úkolů bude rozvíjet vaši tvořivost, podnikavost a další schopnosti. Jsou praktické a také časově náročnější. Proto je jejich zpracování oceněno větším množstvím chechtáků.</p>
                                    </li>
                                    <li>
                                        <div><b>PRO DOSPĚLÁKA</b></div>
                                        <p>Tyto úkoly jsou určené pro dospělého člena vašeho týmu (učitele nebo rodiče). Pomohou vám ve vzájemné komunikaci a hlavně vzájemnému rozvoji.</p>
                                    </li>
                                </ol>
                                <p>Ve spolupráci s letošními partnery – Hraj s rozumem a Critical Thinking Suitcase (CTS) přinášíme v bonusových úkolech ročníku 2024/25 kromě témat z rodinného hospodaření také téma rozvoje <b>kritického myšlení a mediální gramotnosti</b>. Najdete ho jako speciální kategorii. Můžete se také zúčastnit minisoutěže o nejlepší plakát/infografiku (viz kategorii Internet a grafika). Tyto speciální úkoly spouštíme 04. 10. 2024.</p>
                                <p>Více o partnerech si můžete přečíst na <a href="http://www.rozpoctisito.cz/">rozpoctisito.cz</a>, <a href="https://hrajsrozumem.cz/">hrajsrozumem.cz</a> a <a href="https://projectcts.eu/">projects.eu</a>.</p>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['internet']} className='img-fluid'/>
                                                <h5>INTERNET A GRAFIKA</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/1`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['psane_slovo']} className='img-fluid'/>
                                                <h5>PSANÉ SLOVO</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/2`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['pracovni_listy']} className='img-fluid'/>
                                                <h5>KVÍZY A PRACOVNÍ LISTY</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/3`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['audio_video']} className='img-fluid'/>
                                                <h5>AUDIO-VIDEO</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/4`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['prezentace']} className='img-fluid'/>
                                                <h5>PREZENTACE A SEMINÁŘE</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/5`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['hry']} className='img-fluid'/>
                                                <h5>HRY A APLIKACE</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/6`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-content-center'>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['bonus_tasks']['creative']} className='img-fluid'/>
                                                <h5>SPECIÁLNÍ – KRITICKÉ MYŠLENÍ</h5>
                                                <Link to={`/game/${this.getInstanceId()}/bonus-tasks/7`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }}/>
                </Switch>
            </div>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask,
        setTheme: setTheme
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(BonusTasksIndex);
